export default "__VITE_ASSET__2428dae2__"